/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Rails_Visitors_RangeInputs */

const en_directory_rails_visitors_range = /** @type {(inputs: Directory_Rails_Visitors_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 30 days`)
};

const zh_directory_rails_visitors_range = /** @type {(inputs: Directory_Rails_Visitors_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近 30 天`)
};

/**
* | output |
* | --- |
* | "Last 30 days" |
*
* @param {Directory_Rails_Visitors_RangeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_visitors_range = /** @type {((inputs?: Directory_Rails_Visitors_RangeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_Visitors_RangeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_visitors_range(inputs)
	return zh_directory_rails_visitors_range(inputs)
});
export { directory_rails_visitors_range as "directory.rails.visitors_range" }